import { IonIcon } from '@ionic/react';
import { alertCircle, alertCircleOutline, chatbubble, chatbubbleOutline, checkmarkCircle, checkmarkCircleOutline, ellipse, ellipseOutline } from 'ionicons/icons';
import * as React from 'react';
import { DateLocalizer, EventProps, DayLayoutFunction } from 'react-big-calendar';
import { getClient } from '../firebase/clients';
import { getCurrentUser } from '../firebase/firebase';
import { getUser } from '../firebase/users';

export function getEventStatus(event: any) {
    var r;
    let fontSize = 16;
    let style = { position: "absolute", right: "0px", top: "0px", color: "white", fontSize: fontSize + "px" };
    let style_b = { ...style, color: "black" };
    if (event.end < new Date()) {
        if (event.status === 1) {
            r = <div>
                <IonIcon icon={alertCircle} style={style} />
                <IonIcon icon={alertCircleOutline} style={style_b} />
            </div>;
        } else {
            return "";
        }
    }
    else if (event.confirmed) {
        r = <div>
            <IonIcon icon={checkmarkCircle} style={style} />
            <IonIcon icon={checkmarkCircleOutline} style={style_b} />
        </div>;
    } else if (event.reminderSended !== undefined && event.reminderSended=== true) {
        r = <div>
            <IonIcon icon={ellipse} style={style} />
            <IonIcon icon={ellipseOutline} style={style_b} />
        </div>;
    } else {
        return "";
    }
    return <div style={{ position: "relative", right: "-1px", top: "-1px" }}>
        {r}
    </div>;
}

const CustomEventView: React.FC<EventProps> = (props: any) => {
    const c = getClient(props.event.clientId);
    const u = getUser(props.event.userId);
    const currentUser = getCurrentUser();
    const eventStatusStyle = props.event.status === 2 || props.event.status === 3 || props.event.status === 4 ? { textDecoration: "line-through" } : {};


    // const initials = <div style={{ position: "absolute", left: "0px", top:"0px", fontSize:"8px", color:"lightgrey" }}>
    //     {u !== undefined ? u.initials : ""}
    // </div>
    if ((currentUser !== undefined && currentUser.role === "manager")) {
        return (
            <div style={eventStatusStyle} >
                <div >
                    {getEventStatus(props.event)}
                    {c !== undefined ? c.surname + " " + c.name + " " : ""}
                    {c === undefined ? props.event.comments : <div>{props.event.comments}</div>}
                    {c === undefined ? props.event.managerComments : <div>{props.event.managerComments}</div>}
                </div>
            </div>
        );
    } else if (currentUser !== undefined && currentUser.role === "reception") {
        return (
            <div style={eventStatusStyle} >
                {getEventStatus(props.event)}
                {c !== undefined ? c.surname + " " + c.name + " " : ""}
                {c === undefined ? props.event.comments : <div>{props.event.comments}</div>}
            </div>);
    } else if (currentUser !== undefined &&  props.event.userId === currentUser.id) {
        return (
            <div style={eventStatusStyle} >
                <div >
                    {getEventStatus(props.event)}
                    {c !== undefined ? c.surname + " " + c.name + " " : ""}
                    {c === undefined ? props.event.comments : <div>{props.event.comments}</div>}
                </div>
            </div>
        );
    } else {
        return (
            <div style={eventStatusStyle} >

            </div>
        );
    }

};

export default CustomEventView;